import React, { FC } from 'react'
import { usePaginationFragment, graphql } from 'react-relay'

import {
  Text,
  Stack,
  Card,
  Button,
  PresentationItem,
  HorizontalLine,
} from '@components'

import { UserPresentationsScreenUpcomingPresentationsSection_user$key } from './__generated__/UserPresentationsScreenUpcomingPresentationsSection_user.graphql'

export const UserPresentationsScreenUpcomingPresentationsSection: FC<{
  user: UserPresentationsScreenUpcomingPresentationsSection_user$key
}> = ({ user }) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment UserPresentationsScreenUpcomingPresentationsSection_user on User
      @refetchable(
        queryName: "UserPresentationsScreenUpcomingPresentationsSectionPaginationQuery"
      )
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        upcomingPresentations: presentations(
          first: $count
          after: $cursor
          timeSelection: UPCOMING
          orderBy: [CREATED_AT_DESC, ID_ASC]
        )
          @connection(
            key: "UserPresentationsScreenUpcomingPresentationsSection_user_upcomingPresentations"
          ) {
          edges {
            node {
              ...PresentationItem_presentation
            }

            cursor
          }
        }
      }
    `,
    user
  )

  if (data.upcomingPresentations.edges.length === 0) {
    return null
  }

  return (
    <>
      <Stack direction='horizontal' gap={4} alignItems='center'>
        <Text size={4} variant='cardHeading'>
          Upcoming Presentations
        </Text>

        <HorizontalLine variant='cardHeading' />
      </Stack>

      {data.upcomingPresentations.edges.map((edge) => {
        return (
          <Card variant='main' gap={4} key={edge.cursor}>
            <PresentationItem presentation={edge.node} />
          </Card>
        )
      })}

      {hasNext && (
        <Button
          variant='secondary'
          onPress={() => {
            if (isLoadingNext) {
              return
            }

            loadNext(3)
          }}
        >
          <Text variant='buttonSecondary'>
            {isLoadingNext ? 'Loading...' : '+'}
          </Text>
        </Button>
      )}
    </>
  )
}
